<template>
  <sidebar
    :addTitle="$t('CashFlow.Lom.AddNew')"
    :editTitle="$t('CashFlow.Lom.Edit')"
    :isSidebarActive="isSidebarActive"
    :data="data"
    @onNewData="newData"
    @onEditData="editData"
    @closeSidebar="closeSidebar">
    <ValidationObserver ref="observer">
    <vs-tabs v-model="selectedTab">
      <vs-tab value="0" :label="$t('CashFlow.Lom.Tab1')" icon-pack="feather" icon="icon-settings">
        <div class="p-6">
          <vs-row class="mb-3">
            <vs-col vs-w="12">
              <ValidationProvider :name="$t('CashFlow.Lom.Name')" rules="required" v-slot="{ errors }">
                <validated-input
                  :label="$t('CashFlow.Lom.Name')"
                  v-model="corporateLomName"
                ></validated-input>
                <validation-message>{{ errors[0] }}</validation-message>
              </ValidationProvider>
            </vs-col>
          </vs-row>
          <vs-row class="mb-3">
            <vs-col vs-w="12">
              <ValidationProvider :name="$t('CashFlow.Lom.Version')" rules="required" v-slot="{ errors }">
                <validated-input
                  :label="$t('CashFlow.Lom.Version')"
                  v-model="corporateLomVersion"
                ></validated-input>
                <validation-message>{{ errors[0] }}</validation-message>
              </ValidationProvider>
            </vs-col>
          </vs-row>
          <vs-row class="mb-3">
            <vs-col vs-w="12">
              <ValidationProvider :name="$t('CashFlow.Lom.Description')" v-slot="{ errors }">
                <validated-input
                  :label="$t('CashFlow.Lom.Description')"
                  v-model="corporateLomDescription"
                ></validated-input>
                <validation-message>{{ errors[0] }}</validation-message>
              </ValidationProvider>
            </vs-col>
          </vs-row>
          <vs-row class="mb-3">
            <vs-col vs-w="12">
              <form-label>{{$t('CashFlow.Currency.Name')}}</form-label>
              <ValidationProvider :name="$t('CashFlow.Currency.Name')" rules="required" v-slot="{ errors }">
                <v-select
                  label="name"
                  :options="corporateLomCurrencies"
                  v-model="corporateLomCurrency"
                  :reduce="corporateLomCurrency => corporateLomCurrency.id"
                  class="w-full"
                />
                <validation-message>{{ errors[0] }}</validation-message>
              </ValidationProvider>
            </vs-col>
          </vs-row>
          <vs-row class="mb-3">
            <vs-col vs-w="12">
              <ValidationProvider :name="$t('CashFlow.Lom.YearAdjustment')" rules="required" v-slot="{ errors }">
                <validated-input
                  :label="$t('CashFlow.Lom.YearAdjustment')"
                  v-model="corporateLomYearAdjustment"
                ></validated-input>
                <validation-message>{{ errors[0] }}</validation-message>
              </ValidationProvider>
            </vs-col>
          </vs-row>
          <vs-row class="mb-3">
            <vs-col vs-w="12">
              <form-label>{{$t('CashFlow.Lom.Availability')}}</form-label>
              <vs-row>
                <vs-checkbox v-model="corporateLomIsPublic">Public</vs-checkbox>
              </vs-row>
            </vs-col>
          </vs-row>
        </div>
        <div class="p-6">
          <vs-row>
            <vs-col vs-w="12">
              <vs-button class="mr-6" @click="submitData">{{ $t('Submit') }}</vs-button>
              <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false">{{ $t('Cancel') }}</vs-button>
            </vs-col>
          </vs-row>
        </div>
      </vs-tab>
      <vs-tab value="1" :disabled="corporateLomId === null || corporateLomId === 0" :label="$t('CashFlow.Lom.Tab2')" icon-pack="feather" icon="icon-upload">
        <div class="p-6">
          <!-- Upload file -->
            <form data-vv-scope="tab2">
              <vs-row class="mb-6">
                <vs-col vs-w="12">
                  <input type="file" accept=".xlsx" v-on:change="getFile($event)">
                  <div class="mb-3">
                  </div>  
                  <validation-message v-if="showInvalidFileError">{{ $t('CashFlow.Lom.UploadInvalidFileError') }}</validation-message>
                </vs-col>
              </vs-row>
            </form>
            <div>
              <vs-row class="mb-3">
                <vs-col vs-w="12">
                  <vs-button :disabled="!file" class="mr-6" @click="uploadFile">{{ $t('Submit') }}</vs-button>
                  <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false">{{ $t('Cancel') }}</vs-button>
                </vs-col>
              </vs-row>
            </div>
        </div>
      </vs-tab>
    </vs-tabs>
    </ValidationObserver>
  </sidebar>
</template>

<script>
import {
  FormLabel,
  ValidatedInput,
  ValidationMessage,
  Sidebar
} from "./../../../shared/components";

import CurrencyEnum from "./../../CurrencyEnum.js";
import vSelect from 'vue-select';

export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    ValidatedInput,
    ValidationMessage,
    FormLabel,
    Sidebar,
    'v-select': vSelect
  },
  data() {
    return {
      corporateLomId: 0,
      corporateLomName: "",
      corporateLomVersion: 0,
      corporateLomDescription: "",
      corporateLomCurrency: null,
      corporateLomCurrencies: [
        { id:CurrencyEnum.USD, name: this.$t("CashFlow.Currency." + CurrencyEnum.USD) },
        { id:CurrencyEnum.CAD, name: this.$t("CashFlow.Currency." + CurrencyEnum.CAD) },
        { id:CurrencyEnum.EUR, name: this.$t("CashFlow.Currency." + CurrencyEnum.EUR) },
        { id:CurrencyEnum.MXN, name: this.$t("CashFlow.Currency." + CurrencyEnum.MXN) }
      ],
      corporateLomFileContent: "",
      corporateLomYearAdjustment: 0,
      corporateLomIsPublic: 0,
      file: "",
      showInvalidFileError: 0,
      selectedTab: 0
    };
  },
  computed: {
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive;
      },
      set(val) {
        if (!val) {
          this.$emit("closeSidebar");
        }
      }
    }
  },
  methods: {
    getFile(event) {
      if (event.target.files.length > 0) {
        if (event.target.files[0].name !== null && event.target.files[0].name !== "undefined") {
          if (event.target.files[0].name.search(".xlsx") !== -1) {
            this.file = event.target.files[0];
            this.showInvalidFileError = 0;
          }
          else {
            this.showInvalidFileError = 1;
          }
        }
      }
    },
    newData() {
      this.initValues();
      this.$refs.observer.reset();
    },
    editData() {
      const {id, name, version, description, currency, fileContent, yearAdjustment, isPublic} = JSON.parse(JSON.stringify(this.data));
      this.corporateLomId = id;
      this.corporateLomName = name;
      this.corporateLomVersion = version;
      this.corporateLomDescription = description;
      this.corporateLomCurrency = currency;
      this.corporateLomFileContent = fileContent;
      this.corporateLomYearAdjustment = yearAdjustment;
      this.corporateLomIsPublic = isPublic;
      this.file = "";
      this.selectedTab = 0;
      this.showInvalidFileError = 0;
      this.$refs.observer.reset();
    },
    closeSidebar() {
      this.$emit("closeSidebar");
    },
    initValues() {
      if (this.data.id) return;
      this.corporateLomId = 0;
      this.corporateLomName = "";
      this.corporateLomVersion = 0;
      this.corporateLomDescription = "";
      this.corporateLomCurrency = 0;
      this.corporateLomFileContent = "";
      this.corporateLomYearAdjustment = 0;
      this.corporateLomIsPublic = true;
      this.file = "";
      this.showInvalidFileError = 0;
      this.selectedTab = 0;
    },
    submitData() {
      this.$refs.observer.validate().then(result => {
        if (result) {
          const obj = {
            id: this.corporateLomId,
            name: this.corporateLomName,
            version: this.corporateLomVersion,
            description : this.corporateLomDescription,
            currency : this.corporateLomCurrency,
            fileContent : this.corporateLomFileContent,
            yearAdjustment : this.corporateLomYearAdjustment,
            isPublic : this.corporateLomIsPublic
          };

          this.$vs.loading();
          
          if (this.corporateLomId !== null && this.corporateLomId > 0) {
            this.$store.dispatch("cashflow/updateCorporateLom", obj).then((response) => {
              this.$emit("onCorporateLomUpdated", response.data);
            }).finally(() => {
              this.$vs.loading.close();
            });
          } else {
            this.$store.dispatch("cashflow/addCorporateLom", obj).then((response) => {
              this.$emit("onCorporateLomInserted", response.data);
            }).finally(() => {
              this.$vs.loading.close();
            });
          }
        }
      });
    },
    uploadFile() {
      const obj = {
        id: this.corporateLomId,
        name: this.corporateLomName,
        version: this.corporateLomVersion,
        description : this.corporateLomDescription,
        currency : this.corporateLomCurrency,
        fileContent : this.corporateLomFileContent,
        yearAdjustment : this.corporateLomYearAdjustment,
        isPublic : this.corporateLomIsPublic
      };

      if (this.corporateLomId !== null && this.corporateLomId > 0) {
        const formData = new FormData();
        formData.append("files", this.file);
        formData.append("corporateLomId", this.corporateLomId);

        const config = {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        };

        this.$emit("onCorporateLomUploading");
        this.$webApi.post('cashflow/corporateLom/upload/', formData, config)
          .then((response) => {
            if (response.status === 200) {
              this.$emit("onCorporateUploadCompleted", obj);
            }
          }).catch((error) => {
            this.$emit("onCorporateUploadFailed", error);
          });
      }
    }
  }
};
</script>
